"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.apiTool.name': 'Zapytanie API',
    'tools.apiTool.description': 'Zbiera dane z rozmowy i wysyła zapytania API do skonfigurowanych zewnętrznych endpointów',
};
